import { useAppSelector } from "integrations/redux/hooks"
import {
    DownloadButtonData,
    NestedDownloadData,
} from "@nova/component-export-download-buttons-hover"
import { selectActiveSidePanelModal } from "panels/content/side-panel/slice"
import { selectActiveLayerId, selectSelectedLayerIds } from "panels/content/side-panel/slice.new"
import { useImageMetadata } from "./useImageMetadata"
import { selectImageColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { createFlightpathKML } from "@nova/data-create-flight-path-kml"
import { stageKml } from "features/modals/ExportLayers/module"
import { downloadUriSameOrigin } from "tools/browser/download"
import { Licenses } from "@nova/constants"

export const useImageDownloadButtonData = (): DownloadButtonData => {
    // const fireId = useAppSelector(selectActivatedFireId) as string
    const activeSidePanelModalId = useAppSelector(selectActiveSidePanelModal())?.id
    const activeLayerId = useAppSelector(selectActiveLayerId)
    const selectedLayerId = useAppSelector(selectSelectedLayerIds).at(-1)
    const id = activeLayerId || activeSidePanelModalId || selectedLayerId || ""

    const flight = useAppSelector(selectImageColorFinderFlightById(id))
    // const dispatch = useAppDispatch()
    const { imagesMetadata } = useImageMetadata()
    // const { job } = useMonitor(dispatch, useAppSelector, {
    //     id: activeSidePanelModalId || "",
    //     fireId,
    // })
    // const jobIsCompleted = job?.status === JobStatusType.Completed

    const downloadButtonData: NestedDownloadData = {}

    // const downloadImages = async () => {
    //     /*const url = (await fileManagementApi.getDownloadUrl(job.videoPath)) as {
    //         location?: string
    //     }
    //     if (!url?.location) throw new Error("Could not get video download url")
    //     window.open(url.location, "_blank")

    //     const url = (await fileManagementApi.getDownloadUrl(
    //         originalZipFilePath(workspaceId, fireId, flightId)
    //     )) as { location: string }
    //     // Custom naming like this only works for downloadUriSameOrigin.
    //     downloadUri(`${fire.fireNumber} ${chapter.name} ${flight.name} - Images.zip`, url.location)*/
    //     //console.log("TODO: @Jarren")

    // TODO
    // There is no zip in S3 yet. We need to strategize a flow for zipping the images on upload
    // and then storing that in S3. The hotspot Python job has an example of this, where the
    // Dynamo metadata has a flag to indicate that the zip exists or not
    // }

    // return {
    //     Images: { ZIP: downloadImages },
    // }

    const flightPathOptions: NestedDownloadData = {}

    if (imagesMetadata && flight) {
        const downloadFlightPathKML = async () => {
            const flightpath = imagesMetadata?.map((image) => ({
                longitude: image[0],
                latitude: image[1],
                altitude: image[2],
            }))
            const kml = createFlightpathKML(flight.name + " Flightpath", [flightpath], false)

            const files: { blob: Blob; name: string }[] = []
            stageKml(kml, flight.name, files)

            const url = URL.createObjectURL(files[0].blob)
            downloadUriSameOrigin(files[0].name, url)
        }

        flightPathOptions.KML = {
            callback: downloadFlightPathKML,
            restrictedLicenses: [Licenses.Lite],
        }
    }

    if (Object.keys(flightPathOptions).length > 0)
        downloadButtonData["Flight Path"] = flightPathOptions

    return { exportOptions: downloadButtonData }
}
